import * as Yup from "yup";

import { getIsDocumentRequired } from "./getIsDocumentRequired";

export const getDocumentsValidationSchema = (isPartiallyUploading = false) =>
  Yup.array().test(
    "isRequiredDocumentUploaded",
    "Please upload required documents",
    (documents, context) => {
      const [
        {
          value: {
            extraValues: { requiredDocumentsCount },
          },
        } = {},
      ] = context.from || [];
      const requiredUploadedDocumentLength = documents.filter(
        ({ documentRequiredEnum }) =>
          getIsDocumentRequired(documentRequiredEnum, isPartiallyUploading)
      ).length;

      return requiredUploadedDocumentLength === requiredDocumentsCount;
    }
  );
